import { supabase } from "@/integrations/supabase/client";

export type WelcomeEmailSource =
  | "newsletter_homepage"
  | "chapter1_cta"
  | "book_cta"
  | "blog_empty_state"
  | "toolkit_popup_quiz";

/**
 * Fire-and-forget welcome email send. Errors are swallowed silently —
 * subscription flows must always succeed regardless of email outcome.
 */
export const sendWelcomeEmail = (email: string, source: WelcomeEmailSource) => {
  const idempotencyKey = `${source}-${email.toLowerCase()}`;
  void supabase.functions
    .invoke("send-transactional-email", {
      body: {
        templateName: source,
        recipientEmail: email,
        idempotencyKey,
      },
    })
    .catch((err) => {
      console.warn("welcome email send failed (silenced)", err);
    });
};
